import { Navbar } from "../../Components/Navbar";
import { HeroSection } from "../../Components/Home/HeroSection";
import { PathwaysSection } from "../../Components/Home/PathwaysSection";
import { CareerTestSection } from "../../Components/Home/CareerTestSection";
import { ProcessSection } from "../../Components/Home/ProcessSection";
import { PartnersSection } from "../../Components/Home/PartnersSection";
import { TestimonialsSection } from "../../Components/Home/TestimonialsSection";
import { ContactSection } from "../../Components/Home/ContactSection";
import { Footer } from "../../Components/Footer";

export default function HomePage() {
  return (
    <div
      className="min-h-screen bg-[#FAFAFA]"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <Navbar />
      <main>
        <HeroSection />
        <PathwaysSection />
        <CareerTestSection />
        <ProcessSection />
        <PartnersSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
